import { render, staticRenderFns } from "./PdvCallExternal.vue?vue&type=template&id=63fa253a"
import script from "./PdvCallExternal.vue?vue&type=script&lang=js"
export * from "./PdvCallExternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports